var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106.415,
    height: 36.274,
    viewBox: "0 0 106.415 36.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47c2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb0ffa"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.326,33.862,82.232,21.769,70.139,33.862H60.465L77.4,16.932,60.467,0h9.674L82.232,12.1,94.325,0H104L87.07,16.932,104,33.862Zm-58.048,0,7.256-7.256H65.3l-7.256,7.256ZM16.93,16.933V26.6L9.674,33.86V9.677L0,0H9.674V0L16.93,7.256v0l16.93,16.93V0l7.256,7.256V12.1H70.139l4.837,4.837L70.139,21.77H41.116v4.837L38.7,29.026h0L33.86,33.862Zm26.6-9.674L36.278,0H58.046L65.3,7.259Z",
    transform: "translate(1.207 1.207)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6fdd5e631906a63d2e4f0060f0419bf.svg";
export { ForwardRef as ReactComponent };